// @flow

import React, {Component} from 'react';
import {hashedClasses, withCssModule} from '@pb/kit-util-with-css-module';
import MoreLessButton from '../more-less-button';
import {Type, Display, Separator, SEPARATORS} from '../constants';
import styles from './more-endless.component.module.styl';

import type {Node} from 'react';
import type {SeparatorType, DisplayType} from '../constants';
/**
 * @component
 * @name MoreEndless
 * @file
 Use a component to hide part of the data array.
 The component has the ability to step by step display the hidden elements of the end part of the array.
 Hiding once displayed elements is not supporting.
 */

/**
 * MoreEndless Props
 */

const classNames = withCssModule(styles);
const classes = hashedClasses(styles);

type Props = {|
    /**
     * Number of items to be shown initially
     */
    showCount: number,
    /**
     * Number of items that will be opened for display in one step
     */
    moreCount: number,
    /**
     * Set component to show button arrows state
     */
    showArrows: boolean,
    /**
     * Data items
     */
    data: Array<any>,
    /**
     * Mixed class
     */
    mix: string,
    /**
     * Display style
     */
    displaying: DisplayType,
    /**
     * Separator between displaying data items
     */
    separator: SeparatorType,
    /**
     * Wrapper for data item
     */
    children: (item: any) => Node,
    /**
     * Call when click more/less button
     */
    onChange?: (shownItemsCount: number) => void,
|};

type State = {|
    shownItemsCount: number,
|};

export class MoreEndless extends Component <Props, State> {
    static defaultProps = {
        showCount: 3,
        moreCount: 3,
        showArrows: false,
        displaying: Display.BLOCK,
        separator: Separator.SPACE,
        mix: ''
    };

    state = {
        shownItemsCount: this.props.showCount
    };

    onChange = () => {
        const {shownItemsCount} = this.state;
        const {onChange, moreCount} = this.props;

        const nextShownItemsCount = shownItemsCount + moreCount;

        this.setState({
            shownItemsCount: nextShownItemsCount
        });
        if (onChange) {
            onChange(nextShownItemsCount);
        }
    };

    render() {
        const {data, separator, mix, displaying, showArrows} = this.props;
        const {shownItemsCount} = this.state;

        const showButton = data.length > shownItemsCount;
        const endlessClasses = classNames('more-endless', {
            'more-endless_inline': displaying === Display.INLINE,
            [mix]: mix
        });
        return (
            <div className={endlessClasses}>
                {data.slice(0, shownItemsCount).map((el, i) => (
                    <div key={i} className={classes['more-endless__item']}>
                        {this.props.children(el)}{data.length - 1 > i ? `${SEPARATORS[separator]}` : ''}
                    </div>
                ))}
                {showButton ? (
                    <MoreLessButton
                        isCollapsed={true}
                        showArrows={showArrows}
                        type={Type.ARRAY}
                        onChange={this.onChange}
                    />
                ) : null}
            </div>
        );
    }
}

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../constants");
